import { render, staticRenderFns } from "./EvacuationEditor.vue?vue&type=template&id=c020130e"
import script from "./EvacuationEditor.vue?vue&type=script&lang=js"
export * from "./EvacuationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports